import React, { useId } from 'react';
import { createPortal } from 'react-dom';
import { Box } from '../Box';
import { usePortalManager } from '../PortalManager';
export function Portal(props) {
    const container = usePortalManager() || (document === null || document === void 0 ? void 0 : document.body);
    const portalId = useId();
    return container
        ? createPortal(React.createElement(Box, { ...props, "data-mollie-ui-portal": portalId }), container)
        : null;
}
//# sourceMappingURL=Portal.js.map